<template>
    <span class="flex items-center text-xs">
        <font-awesome-icon v-tooltip="'Alteração realizada por automação'" icon="fa-solid fa-bolt" class="mr-1 text-indigo-500 hover:cursor-pointer" />
        <span>TictoBot</span>
    </span>
</template>

<script>
export default {}
</script> 